import { Link } from 'react-router-dom'
import { useBrand } from '@/brand/useBrand'

const APP_VERSION = import.meta.env.VITE_APP_VERSION

export function AppFooter() {
  const { theme } = useBrand()

  return (
    <footer className="flex-shrink-0 border-t border-gray-200 bg-gray-50 px-4 py-2 text-[12px] text-gray-500">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>
          {theme.name} · Analytical tool for licensed professionals · Outputs do
          not constitute accounting, legal, tax, or investment advice.
        </span>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link to="/privacy" className="hover:underline">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:underline">
            Terms of Service
          </Link>
          {APP_VERSION && <span>v{APP_VERSION}</span>}
        </div>
      </div>
    </footer>
  )
}
